function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m438.332031 342.816406c-40.617187 0-73.664062 33.046875-73.664062 73.667969v7.015625h-35v-7.015625c0-40.621094-33.046875-73.667969-73.667969-73.667969s-73.667969 33.046875-73.667969 73.667969v7.015625h-35v-7.015625c0-40.621094-33.046875-73.667969-73.664062-73.667969-40.621094 0-73.667969 33.046875-73.667969 73.667969v95.515625h512v-95.515625c0-40.621094-33.046875-73.667969-73.667969-73.667969zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m222.5 123.976562v60.046876l52-30.023438zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m0 0v308h512v-308zm192.5 235.984375v-163.96875l142 81.984375zm0 0"
});

function Svg65(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg65);
export default __webpack_public_path__ + "static/media/6_5.39bba5e3.svg";
export { ForwardRef as ReactComponent };